import axios from '~/api/axios';
import { AgentAssignee } from '~/types/AgentLead';
import { HandbookRes } from '~/types/Handbook';

export const getMyLeads = async (params: any) => {
  const { page, perPage, ...rest } = params;
  const res = await axios.get<any>('lead/my-leads', {
    params: {
      ...rest,
      pageNumber: page,
      pageSize: perPage,
    },
  });

  console.log('resres', res);
  return res.data;
};

export const createSalesLead = async (body: any) => {
  const res = await axios.post<any>('lead/createNewLead', body);
  return res.data;
};

export const assignSales = async (body: { leadId: string; salesId: string }) => {
  const res = await axios.post<any>('sales/assign', undefined, { params: body });
  return res.data;
};

// Fetch list of sales users for dropdown options
export const getSalesUsers = async () => {
  const res = await axios.get<AgentAssignee[]>('lead/salesUsers');
  return res.data;
};

export const getSales = async () => {
  const res = await axios.get<AgentAssignee[]>('');
  return res.data;
};

export const editLead = async (body: any) => {
  const res = await axios.post<any>('/lead/updateLead', body);
  return res.data;
};

export interface ImportLeadsResult {
  success: boolean;
  message?: string;
  errorType?: 'validation' | 'limit' | 'duplicate' | 'server';
  details?: string;
}

export const importLeads = async (file: File): Promise<ImportLeadsResult> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const res = await axios.post<ImportLeadsResult>('lead/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  } catch (error: any) {
    if (error.response?.data) {
      return {
        success: false,
        errorType: error.response.data.errorType || 'server',
        message: error.response.data.message,
        details: error.response.data.details,
      };
    }
    throw error;
  }
};

export interface ExportLeadsParams {
  fromDate?: string;
  toDate?: string;
  type: 'lastWeek' | 'lastMonth' | 'custom';
}

export const exportLeads = async (params: ExportLeadsParams): Promise<Blob> => {
  const res = await axios.get('lead/export', {
    params: {
      fromDate: params.fromDate,
      toDate: params.toDate,
      type: params.type,
    },
    responseType: 'blob',
  });
  return res.data;
};

export interface BulkEditLeadsParams {
  leadIds: string[];
  assigneeId?: string;
  result?: string;
}

export const bulkEditLeads = async (params: BulkEditLeadsParams) => {
  const res = await axios.post('lead/bulk-edit', params);
  return res.data;
};

// Row result interface
interface RowResult {
  rowNumber: number;
  status: string;
  message: string;
}

// API Response interface (what the backend actually returns)
interface BulkUploadApiResponse {
  status: 'SUCCESS' | 'FAILED';
  message: string;
  fileName?: string;
  totalRecords?: number;
  successCount?: number;
  failedCount?: number;
  rowResults?: RowResult[];
  failedRecordNumbers?: number[];
  errorType?: 'validation' | 'limit' | 'duplicate' | 'server';
  details?: string;
}

// UI-friendly interface (what the frontend expects)
export interface BulkUploadResult {
  success: boolean;
  message?: string;
  errorType?: 'validation' | 'limit' | 'duplicate' | 'server';
  details?: string;
  data?: any;
  totalRecords?: number;
  successCount?: number;
  failedCount?: number;
  rowResults?: RowResult[];
  failedRecordNumbers?: number[];
}

export const validateBulkUpload = async (file: File): Promise<BulkUploadResult> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const res = await axios.post<any>('lead/validateBulkUpload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // Handle potential nested data structure
    const apiResponse = res.data.data || res.data;

    // Transform API response to UI-friendly format
    const transformedResult = {
      success: apiResponse.status === 'SUCCESS',
      message: apiResponse.message,
      totalRecords: apiResponse.totalRecords,
      successCount: apiResponse.successCount,
      failedCount: apiResponse.failedCount,
      failedRecordNumbers: apiResponse.failedRecordNumbers,
      errorType: apiResponse.errorType,
      details: apiResponse.details,
    };

    return transformedResult;
  } catch (error: any) {
    if (error.response?.data) {
      const errorData = error.response.data;
      return {
        success: false,
        errorType: errorData.errorType || 'server',
        message: errorData.message || 'Validation failed',
        details: errorData.details,
      };
    }
    throw error;
  }
};

export const importBulkUpload = async (file: File): Promise<BulkUploadResult> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const res = await axios.post<any>('lead/importBulkUpload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // Handle potential nested data structure
    const apiResponse = res.data.data || res.data;

    return {
      success: apiResponse.status === 'SUCCESS' || res.status === 200,
      message: apiResponse.message || 'Import successful',
      totalRecords: apiResponse.totalRecords,
      successCount: apiResponse.successCount,
      failedCount: apiResponse.failedCount,
      rowResults: apiResponse.rowResults,
      failedRecordNumbers: apiResponse.failedRecordNumbers,
      data: apiResponse, // Include full response data
    };
  } catch (error: any) {
    if (error.response?.data) {
      const errorData = error.response.data;
      return {
        success: false,
        errorType: errorData.errorType || 'server',
        message: errorData.message || 'Import failed',
        details: errorData.details,
      };
    }
    throw error;
  }
};

export const getLeadFilterOptions = async (): Promise<HandbookRes> => {
  const res = await axios.get<HandbookRes>('lead/my-leads/filter-options');
  return res.data;
};

